import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { AppBreadcrumbService } from 'src/app/app.breadcrumb.service';
import { Pdf } from 'src/app/clases/pdf';
import { ProcesoReporte } from 'src/app/pages/base/proceso-reporte';
import { ReporteService } from 'src/app/services/reporte.service';
import { XlsxService } from 'src/app/services/utils/xlsx.service';

@Component({
  selector: 'app-gestion-cartera',
  templateUrl: './gestion-cartera.component.html',
  styleUrls: ['./gestion-cartera.component.scss']
})
export class GestionCarteraComponent extends ProcesoReporte implements OnInit {

    totalAsignado: number = 0
    totalGestionado: number = 0
    totalPromesa: number = 0
    totalNoContactado: number = 0
    totalReagendado: number = 0
    totalCantidadCobrada: number = 0
    totalImporteCobrado: number = 0

    constructor(
        public messageService: MessageService,
        private fb: FormBuilder,
        private router: Router,
        private datePipe: DatePipe,
        private reporteService: ReporteService,
        private breadcrumbService: AppBreadcrumbService,
        private xlsxService: XlsxService
    ) {
        super();
        this.breadcrumbService.setItems([{ label: 'CRM' }, { label: 'Reportes' },  { label: 'Gestion de Cartera' } ]);
        this.iniciarTotales();
    }

    ngOnInit(): void {
        this.crearFormulario();
    }

    iniciarTotales() {
        this.totalAsignado = 0;
        this.totalGestionado = 0;
        this.totalPromesa = 0;
        this.totalNoContactado = 0;
        this.totalReagendado = 0;
        this.totalCantidadCobrada = 0;
        this.totalImporteCobrado = 0;
    }

    async crearFormulario() {
        const hoy = new Date();
        let fecha_desde = new Date(hoy.getFullYear(), hoy.getMonth(),1);
        let fecha_hasta = hoy;
        this.formGroup = this.fb.group({
            fecha_desde: [fecha_desde],
            fecha_hasta: [fecha_hasta],
        })
    }

    async ejecutar(){
        this.iniciarTotales();
        this.items = [];
        const value = this.formGroup.value;
        try {
            this.loading = true;
            const filtros = {
                fecha_desde: this.datePipe.transform(value.fecha_desde, 'yyyy-MM-dd'),
                fecha_hasta: this.datePipe.transform(value.fecha_hasta, 'yyyy-MM-dd'),
            }            
            
            const res = await this.reporteService.gestionCartera( filtros )
            if ( res.ok ) {
                this.items = res.resp;
                if ( this.items.length === 0 ) {
                    this.messageService.add({severity: 'info', 'summary': 'Sin resultados'})
                }
            }
            await this.sumUp();
            this.loading = false;
        } catch (error: any) {
            this.messageService.add({severity: 'error', summary: 'Error', detail: error.message });
        }
    }

    async sumUp() {
        for (const detalle of this.items) {
            this.totalAsignado = Number( detalle.asignado )
            this.totalGestionado = Number( detalle.gestionado )
            this.totalPromesa = Number( detalle.promesas_pago )
            this.totalNoContactado = Number( detalle.no_contactado )
            this.totalReagendado = Number( detalle.reagendado )
            this.totalCantidadCobrada = Number( detalle.cantidad_cobrada )
            this.totalImporteCobrado = Number( detalle.importe_cobrado )
        }
    }

    async descargar() {
        const pdf = new Pdf(this.currentUser);
        pdf.title = 'Seguimiento de Prestamos';
        pdf.headers = [
            // { label: 'Fecha', name: 'fecha_transaccion', type: 'date' },
            { label: 'Entidad', name: 'nombre_entidad', type: 'text' },
            { label: 'Asignado', name: 'asignado', type: 'number' },
            { label: 'Gestionado', name: 'gestionado', type: 'number' },
            { label: 'Promesas de Pago', name: 'promesas_pago', type: 'number' },
            { label: 'No Contactado', name: 'no_contactado', type: 'number' },
            { label: 'Reagendado', name: 'reagendado', type: 'number' },
            { label: 'Cantidad Cobrada', name: 'cantidad_cobrada', type: 'number' },
            { label: 'Importe Cobrado', name: 'importe_cobrado', type: 'number' },

        ]
        for (const item of this.items) {
            pdf.addSource({ data: item });
        }
        
        pdf.foot = {
            headers: [
                { label: 'Total Asignado', name: 'total_asignado', type: 'number' },
                { label: 'Total Gestionado', name: 'total_gestionado', type: 'number' },
                { label: 'Total Promesas', name: 'total_promesa', type: 'number' },
                { label: 'Total No Contactado', name: 'total_no_contactado', type: 'number' },
                { label: 'Total Reagendado', name: 'total_reagendado', type: 'number' },
                { label: 'Total Cantidad Cobrada', name: 'total_cantidad_cobrada', type: 'number' },
                { label: 'Total Importe Cobrado', name: 'total_importe_cobrado', type: 'number' },
            ],
            source: {
                total_asignado: this.totalAsignado,
                total_gestionado: this.totalGestionado,
                total_promesa: this.totalPromesa,
                total_no_contactado: this.totalNoContactado,
                total_reagendado: this.totalReagendado,
                total_cantidad_cobrada: this.totalCantidadCobrada,
                total_importe_cobrado: this.totalImporteCobrado
            }
        }
        pdf.exportar();
    }

    async descargarExcel() {
        const datos: Record<string, any>[] = [];
        for (const item of this.items) {
                datos.push({
                    // "Fecha": this.datePipe.transform(item.fecha_transaccion, 'dd/MM/yyyy'),
                    "Entidad": item.nombre_entidad,
                    "Asignado": item.asignado,
                    "Gestionado": item.gestionado,
                    "Promesas": item.promesas_pago,
                    "No Contactado": item.no_contactado,
                    "Reagendado": item.reagendado,
                    "Cantidad Cobrada": item.cantidad_cobrada,
                    "Importe Cobrada": item.importe_cobrado,
                });
        }
        await this.xlsxService.exportAsExcelFile(datos, 'gestion_cartera');
    }

}
